<template>
  <div id="cat">
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col w-full mb-2">
            <vs-button @click="createAttribute()" class="bg_l_green">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("CreateNewAttribute") }}
            </vs-button>
          </div>
        </div>
        <create-and-modify-popup
          :show="isModifyPopup"
          :currentAttributeName="currentAttributeName"
          @finish="onfinish"
          @close="closeModifyPopup"
        ></create-and-modify-popup>
        <div class="vx-row px-4 flex gap-4 pb-4 w-full sm:w-1/2 lg:w-1/3">
          <div class="flex-grow">
            <label class="vs-select--label">{{ $t("Search") }}</label>
            <vs-input
              name="user"
              :placeholder="$t('AttributeName')"
              v-model="gridSearchData.keyword"
              @keyup.enter="renderGrid"
            />
          </div>
          <div>
            <vs-button
              class="mt-6 p-2"
              color="success"
              type="gradient"
              icon-pack="feather"
              icon="icon-search"
              @click.prevent="renderGrid"
            ></vs-button>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('AttributeName'), sort: 'AttributeName' },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 80%">
                  {{ row.name }}
                </td>
                <td style="width: 20%">
                  <vs-button
                    radius
                    color="success"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    @click.prevent="editAttribute(row)"
                    class="ml-4 d-inline"
                  ></vs-button>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import DataGrid from "@/components/datagrid/DataGrid";
import CreateAndModifyPopup from "./CreateAndModifyPopup.vue";
export default {
  components: {
    DataGrid,
    CreateAndModifyPopup,
  },
  data() {
    return {
      isModifyPopup: false,
      currentAttributeName: "",
      gridDataSource: {
        type: "app",
        service: "ProductManagement/api/AttributesQuery",
      },
      gridSearchData: {},
    };
  },
  methods: {
    ...mapActions({
      fetchAttributes: "attribute/fetch",
    }),
    createAttribute() {
      this.isModifyPopup = true;
    },
    editAttribute(model) {
      this.isModifyPopup = true;
      this.currentAttributeName = model.name;
    },
    closeModifyPopup() {
      this.isModifyPopup = false;
    },
    onfinish() {
      this.$refs.grid.renderGrid();
    },
    renderGrid() {
      this.$refs.grid.renderGrid(1, true);
    },
  },
};
</script>
